import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

const StatementPreviewModal = ({ isOpen, onClose, pdfUrl, startDate, endDate, generatePDF }) => {
  if (!isOpen) return null;

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1 }
  };

  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const handleDownload = () => {
    if (!generatePDF) {
      console.error('generatePDF function not provided');
      toast.error('Failed to download statement');
      return;
    }

    try {
      const doc = generatePDF();
      const fileName = `statement_${format(startDate, 'yyyyMMdd')}_${format(endDate, 'yyyyMMdd')}.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error('Error downloading statement:', error);
      toast.error('Failed to download statement');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/50 z-50"
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={onClose}
          />

          {/* Modal */}
          <motion.div
            className="fixed inset-4 sm:inset-10 z-50 bg-white dark:bg-gray-800 rounded-lg shadow-xl flex flex-col"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b dark:border-gray-700">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Statement Preview
              </h2>
              <button
                onClick={onClose}
                className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 rounded-lg transition-colors"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 p-0 relative bg-gray-100 dark:bg-gray-900 rounded-b-lg">
              <object
                data={`${pdfUrl}#toolbar=0`}
                type="application/pdf"
                className="w-full h-full rounded-b-lg"
              >
                <div className="flex items-center justify-center h-full">
                  <p className="flex flex-col items-center justify-center text-gray-500 dark:text-gray-400">
                    PDF preview is not available on this device.{' '}
                    <button
                      onClick={handleDownload}
                      className="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400"
                    >
                      Download instead
                    </button>
                  </p>
                </div>
              </object>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default StatementPreviewModal; 